"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParseJson = void 0;
function safeParseJson(data) {
    if (!data)
        return {};
    try {
        const value = JSON.parse(data);
        return { value };
    }
    catch (error) {
        return { error };
    }
}
exports.safeParseJson = safeParseJson;
